import { createContext, useReducer, PropsWithChildren, Dispatch } from "react";

export enum ActionType {
    SET_INTEGRATIONS = "set_integrations",
}

export interface IntegrationsPayload {
    // No integrations currently, but keeping structure for future use
}

interface SetIntegrationsAction {
    type: ActionType.SET_INTEGRATIONS;
    payload: IntegrationsPayload;
}

type Action = SetIntegrationsAction;

export interface State {
    // No integrations currently, but keeping structure for future use
}

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case ActionType.SET_INTEGRATIONS:
            return {
                ...state,
                ...action.payload,
            };

        default:
            return state;
    }
};

export const Context = createContext<{
    state: State;
    dispatch: Dispatch<Action>;
}>({
    state: {},
    dispatch: () => {},
});

export const Store = ({ children }: PropsWithChildren<{}>) => {
    const [state, dispatch] = useReducer(reducer, {});

    return (
        <Context.Provider value={{ state, dispatch }}>
            {children}
        </Context.Provider>
    );
};
